export default {
  sections: {
    address: 'Indirizzo aziendale',
    address_help: "Inserisci l'indirizzo a cui è registrata la tua attività. Viene stampato sulle tue fatture.",
  },
  form: {
    legal_form: {
      label: 'Tipo di attività',
      help: "Una UG (haftungsbeschränkt) qui è una GmbH, una e.K. una ditta individuale. Per una OHG o KG, contatta l'assistenza.",
      options: {
        sole_trader: 'Ditta individuale',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Ragione sociale',
      placeholder: 'Inserisci la ragione sociale',
      sole_trader_help: 'Lascia vuoto se operi con il tuo nome personale',
    },
  },
  buttons: {
    next: 'Avanti',
  },
};
